import axios from 'axios';
import _ from 'lodash';

const recieveTags = 'RECIEVE_TAGS';
const updateFilterTags = 'UPDATE_FILTER_TAGS'
const resetFilterTags = 'RESET_FILTER_TAGS'
let request=undefined;

export const tagActions = {
    recieveTags,
    updateFilterTags,
    resetFilterTags
};

export const actionCreators = {
    getTags: ()=>async(dispatch,getState) => {
        if(getState().tagData.tags){
            return;
        } else if(!request){
            request=axios.get(window.global.content_hub.API+'/api/tags',{
                params:{region:window.global.content_hub.region}
            });
            request.then((response)=>{
                let tag_categories=response.data;
                let all_tags=[];
                response.data.forEach(tag_type => {
                    all_tags.push(tag_type.Tags);
                });
                all_tags=_.chain(all_tags).flatten().compact().value();
                dispatch({type:recieveTags, payload:{tag_categories,all_tags}})
            });
        };
    },
    updateFilterTags:(tagArray)=>(dispatch,getState)=>{
        let newTagArray = []
        let temptagArray = tagArray.map(e=>e.Tag_ID);
        getState().tagData.tags.forEach(tagType=>{
            
            newTagArray.push({
                Tag_Type_ID:tagType.Tag_Type_ID,
                Name: tagType.Name,
                Tags: _.chain(tagType.Tags).map(tag=>{
                    var newtag = {...tag}
                    if(_.includes(temptagArray,tag.Tag_ID)){
                        newtag.Content_Count = _.find(tagArray,e=>e.Tag_ID===tag.Tag_ID).Content_Count;
                        return newtag
                    }else{
                        return false;
                    }
                }).compact().value()
            })
           
		})
        dispatch({type:updateFilterTags,payload:newTagArray})
    },
    refreshFilterTags:()=>(dispatch, getState)=>{
        if(getState().tagData.tags){
            dispatch({type: resetFilterTags, payload: getState().tagData.tags})
        }
        else{
            return;
        }
    }

}